import { render, staticRenderFns } from "./BoxCmp.vue?vue&type=template&id=523bcde7&scoped=true&"
import script from "./BoxCmp.vue?vue&type=script&lang=js&"
export * from "./BoxCmp.vue?vue&type=script&lang=js&"
import style0 from "./BoxCmp.vue?vue&type=style&index=0&id=523bcde7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523bcde7",
  null
  
)

export default component.exports